// extracted by mini-css-extract-plugin
export default {"projects-section":"projects_projects-section__ZogYL","title-holder":"projects_title-holder__R0XC+","title":"projects_title__0YzR-"};